//@flow

export { scopedEmitter } from './scoped-emitter'
